export const MOCK_RESPONSES = {
  VIN_LOOKUP: {
    status: 200,
    body: {
      vehicleFound: true,
      vin: '4S4WMAPD2L3406694',
      year: 2020,
      vehicleType: 'SUV',
      make: 'SUBARU',
      model: 'ASCENT',
      style: 'SPORT UTILITY VEHICLE LIMITED',
      errorMessage: null
    }
  }
};
